import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Condition, Iteration } from 'Component/others';
import EmptyState from 'Component/empty-state';
import { TextBold, TextRegular } from 'UiKit/typography';
import useGetHostUpcomingScheduleOverview from 'Domain/host/useGetHostUpcomingScheduleOverview';

import ScheduleCard from 'View/host/component/schedule-card';
import { useHostState } from 'View/host/state';

import styles from './styles.module.css';

const ScheduleOverview = () => {
  const { t } = useTranslation('empty-state', 'host-home');
  const { state, updateState } = useHostState();

  const { data: dataUpcoming } = useGetHostUpcomingScheduleOverview();

  const onChangeExpandedCard = (id) => updateState({ selectedExpandedCard: id });

  return (
    <Box className={styles['schedule-dashboard__container']}>
      <Box className={styles['schedule-dashboard__title']}>
        <TextBold fontSize="16px">{t('host-home:list_live.title')}</TextBold>
      </Box>
      <Box className={styles['list-schedule-dashboard__container']}>
        <Condition
          statement={dataUpcoming?.length}
          fallback={
            <Box marginTop="12px">
              <EmptyState title={t('empty-state:no_data.title')} description={t('empty-state:no_data.description')} background="var(--color-semantic-white)" />
            </Box>
          }
        >
          <Box className={styles['list-schedule-dashboard__not-empty-container']}>
            <TextRegular className={styles['list-schedule-dashboard__list-desc']}>{t('host-home:list_live.description')}</TextRegular>
            <Box className={styles['list-schedule-dashboard__list-iteration']}>
              <Iteration
                items={dataUpcoming}
                render={(schedule, index) => {
                  const isExpand = state?.selectedExpandedCard === schedule?.id;

                  return (
                    <ScheduleCard
                      onChangeExpandedCard={onChangeExpandedCard}
                      isExpand={isExpand}
                      isDefaultExpand={index === 0}
                      key={schedule.id}
                      data={schedule}
                    />
                  );
                }}
              />
            </Box>
          </Box>
        </Condition>
      </Box>
    </Box>
  );
};

export default ScheduleOverview;
